export function onObjectInputChange(key, value, setState,) {
    setState(prev => ({
        ...prev,
        [key]: value
    }))
}

export function onStringInputChange(value, setState,) {
    setState(value)
}